/* ************************************************************************** */
/*                                Dependencies                                */
/* ************************************************************************** */

// Lib dependencies
import { useCallback } from 'react';

// Store
import useWorkspace from '@app/features/Workspace/store/hooks/useWorkspace';

/* ************************************************************************** */
/*                                    Hook                                    */
/* ************************************************************************** */

function useResourceClick() {
  const workspace = useWorkspace();

  const handleResourceClick = useCallback(
    (resourceId: string) => {
      window
        .open(`/workspace/${workspace.id}/file/${resourceId}`, '_blank')
        ?.focus();
    },
    [workspace.id],
  );

  return handleResourceClick;
}

export default useResourceClick;
